import { Link } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_4a6e65b4-dfc4-4116-a52d-9af75b9ab8f4/artifacts/dhbjnlbf_btr%20logo.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-slate-900 text-slate-300 mt-20" data-testid="site-footer">
      <div className="container mx-auto px-4 py-14 max-w-6xl">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          <div className="col-span-2">
            <img src={LOGO} alt="BTR Health" className="h-10 mb-4 brightness-0 invert opacity-90" />
            <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
              An Australian-owned NDIS support marketplace built around participant choice, worker fairness, and zero participant fees.
            </p>
            <p className="text-xs text-slate-500 mt-4">
              BTR HEALTH PTY LTD<br />
              ABN: TBD<br />
              Level 1, Sydney NSW 2000
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Participants</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/how-it-works/participants" className="hover:text-white">How it works</Link></li>
              <li><Link to="/search" className="hover:text-white">Find a worker</Link></li>
              <li><Link to="/post-shift" className="hover:text-white">Post a shift</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing & fees</Link></li>
              <li><Link to="/safety" className="hover:text-white">Safety & insurance</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Workers</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/how-it-works/workers" className="hover:text-white">How it works</Link></li>
              <li><Link to="/worker-signup" className="hover:text-white">Become a support worker</Link></li>
              <li><Link to="/help" className="hover:text-white">Worker help center</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Company</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/help" className="hover:text-white">Help center</Link></li>
              <li><Link to="/safety" className="hover:text-white">Trust & safety</Link></li>
              <li><a href="mailto:hello@btrhealth.com.au" className="hover:text-white">Contact us</a></li>
              <li><Link to="/worker-signup" className="hover:text-white">Join as Worker</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-slate-500">
          <p>© {year} BTR Health Pty Ltd. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/help" className="hover:text-slate-300">Privacy Policy</Link>
            <Link to="/help" className="hover:text-slate-300">Terms of Service</Link>
            <Link to="/help" className="hover:text-slate-300">Cookies</Link>
            <Link to="/help" className="hover:text-slate-300">NDIS Compliance</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
